<mat-checkbox
	[checked]="checked"
	[disabled]="disabled"
	[indeterminate]="indeterminate"
	[color]="color"
	[name]="name"
	[value]="value"
	[labelPosition]="labelPosition"
	[disableRipple]="disableRipple"
	[required]="required"
	[aria-label]="ariaLabel"
	(change)="onInnerChange($event)"
	(indeterminateChange)="onIndeterminate($event)">
	<ng-content></ng-content>
</mat-checkbox>
